import { useState } from "react";
import { useTranslation } from "react-i18next";

import { CustomButton } from "../../../components/CustomButton";
import { CustomModal } from "../../../components/CustomModal";
import { IconNameEnum } from "../../../components/Icon";
import { TextInput } from "../../../components/TextInput";
import { inviteToMobileAppThunk } from "../../../reducers/collectionPointReducer";
import { useAppDispatch } from "../../../store";
import { IModal } from "../../../types/modal";
import { getIsEmailValid } from "../../../utils/validators/getIsEmailValid";

import styles from "./InviteToMobileAppModal.module.scss";

type InviteToMobileAppModal = IModal;

export const InviteToMobileAppModal: React.FC<InviteToMobileAppModal> = ({ isModalVisible, toggleModalVisibility }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const handleChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
    setEmail(event.target.value);
  };

  const handleInviteToMobileApp = async () => {
    if (!getIsEmailValid(email)) {
      setError(t("validation.email"));
      return;
    }

    setIsFetching(true);

    try {
      const res = await dispatch(inviteToMobileAppThunk(email)).unwrap();

      if (res.message === "Email already used") {
        setError(t("validation.emailAlreadyUsed"));
      } else {
        setError("");
        toggleModalVisibility();
      }
    } catch (err: any) {
      setError(err || t("validation.error"));
    }

    setIsFetching(false);
  };

  const clearModalState = () => {
    setEmail("");
    setError("");
  };

  const handleCloseModal = () => {
    clearModalState();
    toggleModalVisibility();
  };

  return (
    <CustomModal
      isModalVisible={isModalVisible}
      toggleModalVisibility={handleCloseModal}
      title="enterEmailOfCollectionPoint"
      text="enterEmailDescriptionText"
    >
      <div className={styles.formContainer}>
        <TextInput
          placeHolder="jan.novotny56@seznam.cz"
          onChange={handleChange}
          value={email}
          error={!!error}
          helperText={error}
          icon={IconNameEnum.mail}
          iconSize={24}
        />
        <CustomButton text={t("sendInvitation")} onClick={handleInviteToMobileApp} disabled={isFetching} />
      </div>
    </CustomModal>
  );
};
